import { render } from "./AdminAddProductModal.vue?vue&type=template&id=a5f354c2"
import script from "./AdminAddProductModal.vue?vue&type=script&lang=js"
export * from "./AdminAddProductModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/LeonardoMBP/Documents/GitHub/swagible-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__